import { render } from "./UserChallengeCard.vue?vue&type=template&id=41c4890a&scoped=true"
import script from "./UserChallengeCard.vue?vue&type=script&lang=js"
export * from "./UserChallengeCard.vue?vue&type=script&lang=js"

import "./UserChallengeCard.vue?vue&type=style&index=0&id=41c4890a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c4890a"]])

export default __exports__